// KPI della console Invio Pratiche (estratto move-only da InvioPratiche.tsx, Fase 5).
import type { KpiView } from "./invioPratiche.shared";

export interface InvioPraticheKpiProps {
  kpi: KpiView;
}

export function InvioPraticheKpi(props: InvioPraticheKpiProps) {
  const { kpi } = props;
  return (
    <>
      {/* KPI — colore semantico, zeri de-enfatizzati */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
        {([
          ["Da inviare", kpi.da_inviare, "text-amber-600"],
          ["Inviate", kpi.inviata, "text-sky-600"],
          ["Accettate", kpi.accettata, "text-green-600"],
          ["Attivate", kpi.attivata, "text-emerald-700"],
          ["Annullate", kpi.annullata, "text-rose-600"],
          ["Errore", kpi.errore, "text-red-600"],
          ["In corso", kpi.in_corso, "text-amber-600"],
        ] as const).map(([label, n, color]) => (
          <div key={label} className="bg-card border border-border rounded-xl p-4 text-center">
            <div className={`text-2xl font-bold tabular-nums ${n > 0 ? color : "text-muted-foreground/40"}`}>{n}</div>
            <div className="text-xs text-muted-foreground mt-1">{label}</div>
          </div>
        ))}
      </div>
    </>
  );
}
